import { Formatter } from '@bingads-webui/listener';
import type { InstrumentationLog } from '../types';

export class ConsoleFormatter extends Formatter {
  format(log: InstrumentationLog): any {
    const logMessage = JSON.stringify(log.message);

    return logMessage;
  }
}
